import React from 'react';
import PropTypes from 'prop-types';
import TreeView from 'components/common/TreeView';
import Spin from 'components/common/Spin';
import Types from 'routes/General/Types';

@autobind
/**
 *
 * @class ListWrapper
 * @extends PureComponen
 */
export default class ListWrapper extends React.PureComponent {
  static propTypes = {
    selected: PropTypes.arrayOf(
      PropTypes.string,
    ),
    onCheck: PropTypes.func,
    title: PropTypes.any,
    checkAll: PropTypes.bool,
    feildValues: PropTypes.object,
    feildOtherValues: PropTypes.object
  };

  static defaultProps = {
    selected: [],
    onCheck: () => {
    },
    checkAll: true,
    feildValues: undefined,
    feildOtherValues: undefined
  };

  /**
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props);

    this.rules = Types.items('WorkingHour.Rules');
    this.state = {
      loading: false,
      selected: props.selected,
    };
  }

  /**
   *
   * @param {Object} np
   */
  componentWillReceiveProps(np) {
    if (_.isEqual(np.defaultValue, this.props.defaultValue)) {
      this.setState({
        selected: Array.isArray(np.defaultValue) ? np.defaultValue : [np.defaultValue],
      });
    }
  }

  /**
   *
   * @return {Array}
   */
  selected() {
    return this.treeView.selected();
  }

  /**
   *
   * @param {Array} _selected
   * @private
   */
  _onCheck(_selected) {
    const {onCheck} = this.props;
    const rules = this.rules;
    let selected = [];


    _selected.map((item) => {
      let _item = rules.find((_item) => _item.id === parseInt(item));
      if (_item && _item.rule) {
        selected.push(`${_item.name}`);
      }
    });

    this.setState({
      selected: _selected,
    });

    onCheck(_selected);
  }

  /**
   *
   * @param {Array} types
   * @param {String} typeId
   * @return {Array}
   * @private
   */
  _renderItems(types, typeId) {
    let items = [];
    const {feildOtherValues} = this.props;
    if (types && types[0]) {
      types.map((type) => {
        // console.log(types, typeId, type.typeId === typeId , !type.rule , type.rule && !type.rule.isPrivate );
        if (type.typeId === typeId && (!type.rule || !type.rule.isPrivate )) {
          items.push({id: type.name, title: type.label, children: this._renderItems(type.children ? type.children : types,type.id)});
        }
      });
    }

    if (feildOtherValues && feildOtherValues.otherValues && !typeId) {
      let keys = Object.keys(feildOtherValues.otherValues || {}) || [];
      keys.map((key) => {
          items.push({id: key, title: app.translate(`routes.home.attendance.rules.${feildOtherValues.otherValues[key]}`, feildOtherValues.otherValues[key]), children: []});
      });
    }

    return items;
  }
  /**
   * @return {Array}
   * @private
   */
  _renderFeildValues() {
    let {feildValues} = this.props;
    let items = [];
    if (feildValues) {
      let keys = Object.keys(feildValues) || [];
      keys.map((key) => {
          items.push({id: key, title: app.translate(`routes.home.attendance.rules.${feildValues[key]}`, feildValues[key]), children: []});
      });
    }
    return items;
  }

  /**
   *permissions
   * @return {Array}
   * @private
   */
  _renderData() {
    return this._renderItems(this.rules, null);
  }

  /**
   *
   * @readonly
   * @memberof ListWrapper
   */
  get _selected() {
    const {selected} = this.state;
    const rules = this.rules;
    let _selected = [];

    selected.map((item) => {
      let _item = rules.find((_item) => _item.rule && _item.rule.id === parseInt(item));
      if (_item) {
        _selected.push(`${_item.id}`);
      }
    });

    return selected;
  }

  /**
   *
   * @return {XML}
   */
  render() {
    const {loading} = this.state;
    const {checkAll, title, feildValues} = this.props;

    return (

      <div
        style={{
          height: 'calc(300px)',
          overflow: 'auto',
        }}
      >
        <Spin
          spinning={loading}
          style={{
            height: '100%',
          }}
        >
          <TreeView
            checkable
            title={title}
            showSearch={false}
            onCheck={this._onCheck}
            treeData={
              // feildValues ? this._renderFeildValues() : 
              this._renderData()
            }
            defaultCheckedKeys={this._selected}
            checkAllButton={checkAll}
            treeStyle={{height: 'calc(100% - 44px)'}}
            ref={(input) => this.treeView = input}
          />
        </Spin>
      </div>
    );
  }
}
